


































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Action, Getter } from 'vuex-class';

@Component
export default class TransactionsTable extends Vue {
  public yearAndMonthMenu: boolean = false;
  public showFilters: boolean = true;

  get headersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.transactions.subjectable'),
        value: 'subjectable',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.amount'),
        value: 'amount',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.balance'),
        value: 'balance',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.transactable'),
        value: 'transactable',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.parentable'),
        value: 'parentable',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.subtype'),
        value: 'subtype',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.shift_type'),
        value: 'shift_type',
        sortable: false,
      },
      {
        text: this.$t('table_headers.transactions.note'),
        value: 'note',
        sortable: false,
      },
      {
        text: this.$t('table_headers.shared.created_at'),
        value: 'created_at',
        sortable: false,
      },
    ];
  }

  get filters() {
    return {
      subject: this.subject,
      subjectName: this.subjectName,
      transactionType: this.transactionType,
      date: this.date,
      shiftType: this.shiftType,
      shiftId: this.shiftId,
      itemsPerPage: this.itemsPerPage,
    };
  }

  @Watch('filters', { deep: true })
  @Debounce(500)
  handleFilters() {
    this.currentPage = 1;
    this.fetchTransactions();
  }

  @Watch('currentPage')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
    this.fetchTransactions();
  }

  @Action('transactions/setSubject') setSubject: any;
  @Getter('transactions/subjects') subjects: any;
  @Getter('transactions/subject') subjectState: any;
  public get subject(): string {
    return this.subjectState;
  }
  public set subject(subject: string) {
    this.setSubject(subject);
  }

  @Action('transactions/setSubjectName') setSubjectName: any;
  @Getter('transactions/subjectName') subjectNameState: any;
  public get subjectName(): string {
    return this.subjectNameState;
  }
  public set subjectName(subjectName: string) {
    this.setSubjectName(subjectName);
  }

  @Action('transactions/setTransactionType') setTransactionType: any;
  @Getter('transactions/transactionTypes') transactionTypes: any;
  @Getter('transactions/transactionType') transactionTypeState: any;
  public get transactionType(): string {
    return this.transactionTypeState;
  }
  public set transactionType(transactionType: string) {
    this.setTransactionType(transactionType);
  }

  @Action('transactions/setDate') setDate: any;
  @Getter('transactions/date') dateState: any;
  public get date(): string {
    return this.dateState;
  }
  public set date(date: string) {
    this.setDate(date);
  }

  @Action('transactions/setShiftType') setShiftType: any;
  @Getter('transactions/shiftTypes') shiftTypes: any;
  @Getter('transactions/shiftType') shiftTypeState: any;
  public get shiftType(): any {
    return this.shiftTypeState;
  }
  public set shiftType(val: any) {
    this.setShiftType(val);
  }

  @Action('transactions/setShiftId') setShiftId: any;
  @Getter('transactions/shiftId') shiftIdState: any;
  public get shiftId(): string {
    return this.shiftIdState;
  }
  public set shiftId(val: string) {
    this.setShiftId(val);
  }

  @Action('transactions/fetchTransactions') fetchTransactions: any;
  @Getter('transactions/transactions') transactions: any;

  @Action('transactions/setTransactionsLoading') setTransactionsLoading: any;
  @Getter('transactions/transactionsLoading') transactionsLoadingState: any;
  public get transactionsLoading(): boolean {
    return this.transactionsLoadingState;
  }
  public set transactionsLoading(value: boolean) {
    this.setTransactionsLoading(value);
  }

  @Getter('transactions/total') total: any;
  @Action('transactions/clearPayload') clearFilters: any;
  @Getter('transactions/payload') payload: any;

  @Action('transactions/setCurrentPage') setCurrentPage: any;
  @Getter('transactions/currentPage') currentPageState: any;
  public get currentPage(): number {
    return this.currentPageState;
  }
  public set currentPage(page: number) {
    this.setCurrentPage(page);
  }

  @Action('transactions/setItemsPerPage') setItemsPerPage: any;
  @Getter('transactions/itemsPerPage') itemsPerPageState: any;
  public get itemsPerPage(): number {
    return this.itemsPerPageState;
  }
  public set itemsPerPage(itemsPerPage: number) {
    this.setItemsPerPage(itemsPerPage);
  }

  mounted() {
    this.fetchTransactions();
  }
}
